module.exports = __webpack_public_path__ + "img/detail_pic_huodong.1766306608134.png";